import React, { Fragment } from 'react';

import useListboxFetch from "./useListboxFetch";
import { CommonDropdown } from "./CommonDropdown";
import SpinnerDiv from "ui/ReactSpinnerDiv";

const DropdownPupil = ( { control, name, rules, placeholder, isSearchable, isClearable, isMulti, readOnly, school_id, mode } ) =>
{
    const USER_TYPE_PUPIL = 2;

    const url = '/school/' + school_id + '/users/' + USER_TYPE_PUPIL ;

    const fields = { url: url, keyFieldName: 'unenc_user_id', labelFieldName: 'name', additionalFields: ['user_account_id'] }

    const [ loading, items ] = useListboxFetch( fields ) ;

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items} control={control} name={name} rules={rules} placeholder={placeholder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} /> }
        </Fragment>
    )
}

export default DropdownPupil;
